/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react"
import { Section } from "components/footer/FooterStyled"
import { StakeCurrencyWrapper } from "./style"
import {
  Button,
  SFXS,
  Currencies,
  mathOperations,
} from "@orbitalgaming/games-frontend-library"
import { colors } from "lib/colors"

const ButtonGroup = ({
  stake,
  handleStake,
  handleAbove,
  audio,
  handleNotification,
  gameInfo,
  handleCurrentStake,
  handleCurrentName,
  currentName,
  isZero,
  active,
}: any) => {
  const [number, setnumber] = useState(stake)
  const { minBet, maxBet, precision, currency } = gameInfo

  useEffect(() => {
    setnumber((+stake).toFixed(precision))
  }, [stake, precision])
  const handlePlay = () => {
    handleAbove("SetStake")
    handleCurrentStake(number)
    handleCurrentName(currentName)
  }
  return (
    <Section>
      <Button
        width='56px'
        audio={audio}
        borderColor={colors.secondary}
        background={colors.secondaryDark}
        textColor={colors.tertiary}
        size='18px'
        func={(e?: boolean) =>
          e &&
          handleStake(
            mathOperations(
              stake,
              "1/2",
              precision,
              maxBet,
              minBet,
              handleNotification,
              currency,
              isZero,
            ),
          )
        }
        SFX={SFXS.divideSFX}
      >
        1/2
      </Button>
      <Button
        audio={audio}
        borderColor={colors.secondary}
        background={active ? colors.primaryLight : colors.primaryDark}
        textColor={colors.secondary}
        width='173px'
        size='18px'
        border='3px solid'
        func={(b: boolean) => b && handlePlay()}
        SFX={SFXS.goForwardSFX}
      >
        <StakeCurrencyWrapper>
          <p className='currency'>{Currencies[currency]}</p>
          <p className='amount'>{number}</p>
        </StakeCurrencyWrapper>
        {/* todo change number to current stake */}
      </Button>
      <Button
        size='18px'
        width='56px'
        audio={audio}
        borderColor={colors.secondary}
        background={colors.secondaryDark}
        textColor={colors.tertiary}
        func={(e?: boolean) =>
          e &&
          handleStake(
            mathOperations(
              stake,
              "2x",
              precision,
              maxBet,
              minBet,
              handleNotification,
              currency,
              isZero,
            ),
          )
        }
        SFX={SFXS.multiplySFX}
      >
        2x
      </Button>
    </Section>
  )
}
export default ButtonGroup
